import { useMemo } from 'react';

import { memoGeneric } from '@/js/libs/memo/index.ts';

import type { FormatOptionLabel, Option } from '../../types.ts';
import { LabelWrapper, Tag, Value } from './styled.ts';

interface SelectedLabelProps<T> {
  selected: Option<T>[];
  label?: string;
  formatOptionLabel?: FormatOptionLabel<T>;
}

export const SelectedLabel = memoGeneric(function SelectedLabel<T>({ selected, label, formatOptionLabel }: SelectedLabelProps<T>) {
  const selectedLabel = useMemo(
    () => (formatOptionLabel && selected[0] ? formatOptionLabel(selected[0]) : selected[0]?.label),
    [formatOptionLabel, selected],
  );
  return (
    <LabelWrapper>
      {label && (
        <span>
          {label}
          {':'}
        </span>
      )}
      <Value data-testid='dropdown-value'>{selectedLabel}</Value>
      {selected.length - 1 > 0 && <Tag data-testid='tag-length'>{`+${selected.length - 1}`}</Tag>}
    </LabelWrapper>
  );
});
